
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.334 28c4.703-2.063 7.999-6.545 7.999-12s-3.296-9.937-7.999-12v2.667c3.183 1.848 5.332 5.396 5.332 9.333 0 3.937-2.15 7.485-5.332 9.333V28z","fill":"#43B4EB"}}),_c('path',{attrs:{"d":"M21.333 9.333v13.334C22.966 21.2 23.999 18.36 23.999 16c0-2.361-1.033-5.2-2.666-6.667zm-16 13.334h3.596l9.737 6.49V2.843l-9.737 6.49H5.333A2.67 2.67 0 002.666 12v8a2.67 2.67 0 002.667 2.667z","fill":"#43B4EB"}})])
          )
        }
      }
    